import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";
import { IRole } from "../../interfaces";

export default function useRoles() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();
    const queryClient = useQueryClient();

    function useList() {
        return useQuery<IRole[]>({
            queryKey: ["roles"],
            queryFn: async () => {
                const response = await axiosPrivate.get("/v1/roles/");
                return parseSuccessResponseData(response);
            },
        });
    }

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: { Id?: string; Name: string; Description?: string }) =>
                axiosPrivate.post(`/v1/roles/`, parameters).then(parseSuccessResponseData),
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["roles"] });
            },
        });
    }

    function useUpdate() {
        return useMutation({
            mutationFn: (parameters: { Id: string; Name?: string; Description?: string }) =>
                axiosPrivate.put(`/v1/roles/`, parameters).then(parseSuccessResponseData),
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["roles"] });
            },
        });
    }

    function useDelete() {
        return useMutation({
            mutationFn: (parameters: { Id: string }) =>
                axiosPrivate.delete(`/v1/roles/${parameters.Id}`).then(parseSuccessResponseData),
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["roles"] });
            },
        });
    }

    return { useList, useCreate, useUpdate, useDelete };
}
